import { render, staticRenderFns } from "./ServiceTime.vue?vue&type=template&id=13870be9&"
import script from "./ServiceTime.vue?vue&type=script&lang=js&"
export * from "./ServiceTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports